module.exports = __webpack_public_path__ + "static/media/11.102.d7fd9d2b.webp";